import api from "@/services/axios";

// Generic tenant-scoped design-token store. Deliberately not "SchoolTheme" — this module is
// meant to be reusable by any tenant surface. Phase 0 only reads/writes the 4 sidebar.* keys;
// future phases add keys here, never new endpoints or new files. See
// docs/plan/brand-kit/README.md in the sms-modular-monolith-ddd repo.

export type BrandKitTokens = Record<string, string>;

export type BrandKit = {
  tokens: BrandKitTokens;
  isCustom: boolean;
  version: number;
};

type ApiResponse<T> = {
  data?: T;
  success?: boolean;
  message?: string;
  errors?: Array<{ message?: string | null; target?: string | null }> | null;
};

type BrandKitApi = {
  tokens?: BrandKitTokens;
  Tokens?: BrandKitTokens;
  isCustom?: boolean;
  IsCustom?: boolean;
  version?: number;
  Version?: number;
};

function unwrapApiResponse<T>(payload: ApiResponse<T>): T {
  if (payload?.success === false) {
    const firstError = payload?.errors?.[0]?.message;
    throw new Error(firstError || payload.message || "Request failed.");
  }

  if (payload?.data === undefined) {
    throw new Error(payload?.message || "Unexpected API response.");
  }

  return payload.data;
}

function toBrandKit(raw: BrandKitApi): BrandKit {
  return {
    tokens: raw.tokens ?? raw.Tokens ?? {},
    isCustom: raw.isCustom ?? raw.IsCustom ?? false,
    version: raw.version ?? raw.Version ?? 0,
  };
}

export async function getBrandKit(): Promise<BrandKit> {
  const response = await api.get<ApiResponse<BrandKitApi>>("/brand-kit");
  return toBrandKit(unwrapApiResponse(response.data));
}

export async function saveBrandKit(tokens: BrandKitTokens): Promise<BrandKit> {
  const response = await api.put<ApiResponse<BrandKitApi>>("/brand-kit", { tokens });
  return toBrandKit(unwrapApiResponse(response.data));
}

export async function resetBrandKit(): Promise<BrandKit> {
  const response = await api.post<ApiResponse<BrandKitApi>>("/brand-kit/reset");
  return toBrandKit(unwrapApiResponse(response.data));
}
